import { render } from "./APIIntegration.vue?vue&type=template&id=782ed057&scoped=true"
import script from "./APIIntegration.vue?vue&type=script&lang=js"
export * from "./APIIntegration.vue?vue&type=script&lang=js"

import "./APIIntegration.vue?vue&type=style&index=0&id=782ed057&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782ed057"]])

export default __exports__